import PlanDogIcon from 'assets/images/plan_dog.svg';
import React from 'react';

import { Box, Stack, Typography, useTheme } from '@mui/material';

interface Props {
  planName: string;
  planPrice: number;
  discountPlanPrice?: number;
  installmentText?: string;
}

export const TutorPlanCardHeader: React.FC<Props> = ({
  planName,
  planPrice,
  discountPlanPrice,
  installmentText
}) => {
  const { palette } = useTheme();

  const [integerPrice, decimalPrice] = Number(planPrice).toFixed(2).split('.');

  const [integerPriceDiscount, decimalPriceDiscount] = Number(discountPlanPrice)
    .toFixed(2)
    .split('.');

  return (
    <Stack direction="row" spacing={3} alignSelf="center">
      <Box component="img" alt="Ícone plano" src={PlanDogIcon} width={107} />

      <Stack spacing={2}>
        <Typography fontWeight={500} fontSize={28} color={palette.primary.main}>
          {planName}
        </Typography>

        {Boolean(discountPlanPrice) && (
          <Stack direction="row" position="relative">
            <Typography mr={1} fontWeight={400} fontSize={26} color="#DADADA">
              R$
            </Typography>

            <Typography fontWeight={400} fontSize={26} color="#DADADA">
              {integerPrice}
            </Typography>

            <Typography
              fontWeight={400}
              fontSize={26}
              color="#DADADA"
              alignSelf="flex-end"
            >
              ,{`${decimalPrice} ${installmentText ? '' : '/mês'}`} +
            </Typography>
            <div
              style={{
                zIndex: 1,
                width: '100%',
                marginTop: 20,
                position: 'absolute',
                transform: 'rotate(-10deg)',
                borderBottom: '2px solid rgba(75, 75, 75, 1)',
              }}
            />
          </Stack>
        )}

        <Stack direction="row">
          <Typography
            mr={1}
            fontWeight={400}
            fontSize={26}
            lineHeight={1}
            color="#7A8388"
          >
            R$
          </Typography>

          <Typography
            fontWeight={500}
            fontSize={58}
            lineHeight="55px"
            color="#4B4B4B"
          >
            {Boolean(discountPlanPrice) ? integerPriceDiscount : integerPrice}
          </Typography>

          <Typography
            fontWeight={400}
            fontSize={26}
            lineHeight={1}
            marginLeft={-1}
            color="#7A8388"
            alignSelf="flex-end"
          >
            {Boolean(discountPlanPrice)
              ? `,${decimalPriceDiscount} ${installmentText ? '' : '/mês'}`
              : `,${decimalPrice} ${installmentText ? '' : '/mês'}`}
          </Typography>
        </Stack>
        <Typography
            mr={1}
            fontWeight={800}
            fontSize={'1em'}
            color="#7A8388"
          >
            {installmentText}
          </Typography>
      </Stack>
    </Stack>
  );
};
